import LtiResourceContent from '@/models/LtiResourceContent.js';
import LtiResourceLink from '@/models/LtiResourceLink.js';
import Model from '@/models/Model.js';

export default class LtiToolActivity extends Model {
    static entity = 'lti_tool_activities';

    static modelName = 'LtiToolActivity';

    static fields() {
        return {
            id: this.attr(null),
            content_template_id: this.attr(null),
            lti_resource_link_id: this.attr(null),
            lti_resource_content_id: this.attr(null),
            content: this.attr(null),

            ...super.fields(),

            ltiResourceLink: this.belongsTo(LtiResourceLink, 'lti_resource_link_id'),
            ltiResourceContent: this.belongsTo(LtiResourceContent, 'lti_resource_content_id'),
            activity: this.morphOne('activities', 'contentable_id', 'contentable_type_entity'),
        };
    }
}
